(function () {
  'use strict';

  var app = angular.module('app');

  // Collect the routes
  app.constant('routes', getRoutes());

  // Configure the routes and route resolvers
  app.config(['$routeProvider', 'routes', routeConfigurator]);
  function routeConfigurator($routeProvider, routes) {

    routes.forEach(function (r) {
      $routeProvider.when(r.url, r.config);
    });
    $routeProvider.otherwise({ redirectTo: '/' });
  }

  // Define the routes 
  function getRoutes() {
    return [
      {
        url: '/',
        config: {
          title: 'dashboard',
          templateUrl: '/app/dashboard/dashboard_error.html?version=30'
        }
      },
      {
        url: '/dashboard_Super',
        config: {
          title: 'dashboard',
          templateUrl: '/app/dashboard/dashboard_Super.html?version=30'
        }
      },
      {
        url: '/dashboard_Utente',
        config: {
          title: 'dashboard',
          templateUrl: '/app/dashboard/dashboard_Utente.html?version=30'
        }
      },
      {
        url: '/dashboard_Personale',
        config: {
          title: 'dashboard',
          templateUrl: '/app/dashboard/dashboard_Personale.html?version=30'
        }
      },
      {
        url: '/dashboard_CapoSezione',
        config: {
          title: 'dashboard',
          templateUrl: '/app/dashboard/dashboard_CapoSezione.html?version=30'
        }
      },
      // CURRICULUM
      {
        url: '/curriculum',
        config: {
          title: 'curriculum',
          templateUrl: '/app/curriculum/curricula.html?version=30'
        }
      },
      // CURRICULUM PERSONALE
      {
        url: '/curriculum_personale',
        config: {
          title: 'curriculum_personale',
          templateUrl: '/app/curriculum_personale/curricula_personale.html?version=30'
        }
      },
      // CURRICULUM
      {
        url: '/curriculum_personale/:DipendenteId',
        config: {
          title: 'curriculum_personaleDetail',
          templateUrl: '/app/curriculum_personale/curricula_personale.html?version=30'
        }
      },
      // DIPENDENTI
      {
        url: '/dipendente',
        config: {
          title: 'dipendente',
          templateUrl: '/app/dipendente/dipendenti.html?version=30'
        }
      },
      {
        url: '/dipendente/:DipendenteId',
        config: {
          title: 'dipendenteDetail',
          templateUrl: '/app/dipendente/dipendenti.html?version=30'
        }
      },
      //DIPENDENTI SUPER
      {
        url: '/dipendente_super',
        config: {
          title: 'dipendente',
          templateUrl: '/app/dipendente_super/dipendenti.html?version=30'
        }
      },
      {
        url: '/dipendente_super/:DipendenteId',
        config: {
          title: 'dipendenteDetail',
          templateUrl: '/app/dipendente_super/dipendenti.html?version=30'
        }
      },
      // AZIENDEPARTNER
      {
        url: '/aziendaPartner',
        config: {
          title: 'aziendaPartner',
          templateUrl: '/app/aziendaPartner/aziendePartner.html?version=30'
        }
      },
      {
        url: '/aziendaPartner/:AziendaPartnerId',
        config: {
          title: 'aziendaPartner',
          templateUrl: '/app/aziendaPartner/aziendePartner.html?version=30'
        }
      },
      // AZIENDE
      {
        url: '/azienda',
        config: {
          title: 'azienda',
          templateUrl: '/app/azienda/aziende.html?version=30'
        }
      },
      {
        url: '/azienda/:AziendaId',
        config: {
          title: 'azienda',
          templateUrl: '/app/azienda/aziende.html?version=30'
        }
      },
      // CLIENTI
      {
        url: '/cliente',
        config: {
          title: 'cliente',
          templateUrl: '/app/cliente/clienti.html?version=30'
        }
      },
      {
        url: '/cliente/:ClienteId',
        config: {
          title: 'cliente',
          templateUrl: '/app/cliente/clienti.html?version=30'
        }
      },
      // REPORT ORE
      {
        url: '/reportOre',
        config: {
          title: 'reportOre',
          templateUrl: '/app/reportOre/reportOre.html?version=30'
        }
      },
      // TIMESHEET
      {
        url: '/timeSheet',
        config: {
          title: 'timeSheet',
          templateUrl: '/app/timeSheet/timeSheet.html?version=30'
        }
      },
      {
        url: '/timeSheet/:DipendenteId/:Data',
        config: {
          title: 'timeSheet',
          templateUrl: '/app/timeSheet/timeSheet.html?version=30'
        }
      },
      // TIMESHEET MENSILE
      {
        url: '/timeSheetMensile',
        config: {
          title: 'timeSheetMensile',
          templateUrl: '/app/timeSheetMensile/timeSheetMensile.html?version=30'
        }
      },
      // REPORT 
      {
        url: '/report',
        config: {
          title: 'report',
          templateUrl: '/app/report/report.html?version=30'
        }
      },
      // REPORT SUPER
      {
        url: '/report_super',
        config: {
          title: 'report_super',
          templateUrl: '/app/report_super/report_super.html?version=30'
        }
      },
      // COMMESSE
      {
        url: '/commesse',
        config: {
          title: 'commesse',
          templateUrl: '/app/commessa/commesse.html?version=30'
        }
      },
      {
        url: '/commesse/:CommessaId',
        config: {
          title: 'commesse',
          templateUrl: '/app/commessa/commesse.html?version=30'
        }
      },
      // OFFERTE
      {
        url: '/offerte',
        config: {
          title: 'offerte',
          templateUrl: '/app/offerta/offerte.html?version=30'
        }
      },
      {
        url: '/offerte/:CommessaId',
        config: {
          title: 'offerte',
          templateUrl: '/app/offerta/offerte.html?version=30'
        }
      },
      //SEZIONI
      {
        url: '/sezioni',
        config: {
          title: 'sezione',
          templateUrl: '/app/sezioni/sezioni.html?version=30'
        }
      },
      // AVANZAMENTI COMMESSE
      {
        url: '/avanzamentiCommesse',
        config: {
          title: 'avanzamentiCommesse',
          templateUrl: '/app/avanzamentoCommessa/avanzamentoCommesse.html?version=30'
        }
      },
      //VERIFICA
      {
        url: '/validaTimeSheet',
        config: {
          title: 'validaTimeSheet',
          templateUrl: '/app/validaTimeSheet/validaTimeSheet.html?version=30'
        }
      },
      // USER
      {
        url: '/user',
        config: {
          title: 'users',
          templateUrl: '/app/user/users.html?version=30'
        }
      },
      {
        url: '/user/:UserId',
        config: {
          title: 'userDetail',
          templateUrl: '/app/user/users.html?version=30'
        }
      },
      // LOGS   
      {
        url: '/logs',
        config: {
          title: 'logs',
          templateUrl: '/app/logPush/logPush.html?version=30'
        }
      },
      // ATTIVITA'   
      {
        url: '/attivita',
        config: {
          title: 'attivita',
          templateUrl: '/app/attivita/attivita.html?version=30'
        }
      },
      // GIUSTIFICATIVI   
      {
        url: '/giustificativi',
        config: {
          title: 'giustificativi',
          templateUrl: '/app/giustificativi/giustificativi.html?version=30'
        }
      },
      // PARAMETRI   
      {
        url: '/parametri',
        config: {
          title: 'parametri',
          templateUrl: '/app/parametri/parametri.html?version=30'
        }
      },
      {
        url: '/parametri/:parametriId',
        config: {
          title: 'parametri',
          templateUrl: '/app/parametri/parametri.html?version=30'
        }
      },
      // TEAM
      {
        url: '/team',
        config: {
          title: 'team',
          templateUrl: '/app/team/team.html?version=30'
        }
      },
      // COSTI BASE
      {
        url: '/costiBase',
        config: {
          title: 'costiBase',
          templateUrl: '/app/costiBase/costiBase.html?version=30'
        }
      },
      // PROFILO ORARIO
      {
        url: '/profiloOre',
        config: {
          title: 'profiloOre',
          templateUrl: '/app/profiloOre/profiloOre.html?version=30'
        }
      },
      // ATTIVITA' CONTROLLO
      {
        url: '/attivitaControllo',
        config: {
          title: 'attivitaControllo',
          templateUrl: '/app/attivitaControllo/attivitaControllo.html?version=30'
        }
      },
      // AUTORIZZAZIONE
      {
        url: '/autorizzazione',
        config: {
          title: 'autorizzazione',
          templateUrl: '/app/autorizzazione/autorizzazioni.html?version=30'
        }
      },
      //T_ATTACH
      {
        url: '/tAttach',
        config: {
          title: 'tAttach',
          templateUrl: '/app/tAttach/tAttach.html?version=30'
        }
      },
      {
        url: '/tAttach/:TAttachId',
        config: {
          title: 'tAttach',
          templateUrl: '/app/tAttach/tAttach.html?version=30'
        }
      },
      //RICHIESTEFERIE
      {
        url: '/richiestaFerie',
        config: {
          title: 'richiestaFerie',
          templateUrl: '/app/richiestaFerie/richiestaFerie.html?version=30'
        }
      },
      {
        url: '/richiestaFerie/:RichiestaFerieId',
        config: {
          title: 'richiestaFerie',
          templateUrl: '/app/richiestaFerie/richiestaFerie.html?version=30'
        }
      },
      //VALIDAZIONEFERIE
      {
        url: '/validazioneFerie',
        config: {
          title: 'validazioneFerie',
          templateUrl: '/app/validazioneFerie/validazioneFerie.html?version=30'
        }
      },
      {
        url: '/richiestaFerie/:ValidazioneFerieId',
        config: {
          title: 'validazioneFerie',
          templateUrl: '/app/validazioneFerie/validazioneFerie.html?version=30'
        }
      }
    ];
  }
})();
